import { render, staticRenderFns } from "./tour_compass_button.vue?vue&type=template&id=136203ef&scoped=true&"
import script from "./tour_compass_button.vue?vue&type=script&lang=js&"
export * from "./tour_compass_button.vue?vue&type=script&lang=js&"
import style0 from "./tour_compass_button.vue?vue&type=style&index=0&id=136203ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136203ef",
  null
  
)

export default component.exports